import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { ServiceAccount } from "../../schema/types/serviceAccount/entity";

export const serviceAccountApi = createApi({
  reducerPath: "serviceAccountApi",
  baseQuery: customBaseQuery,
  tagTypes: ["ServiceAccount", "ServiceAccountInfo"],
  endpoints: (builder) => ({
    getServiceAccount: builder.query<ServiceAccount, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: link });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "ServiceAccount", id: link }],
    }),
    addKey: builder.mutation<string, { link: string; description: string }>({
      queryFn: async ({ link, description }) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({
            method: "post",
            url: link + `/-addKey`,
            body: { description: description },
          });
          return { data: data.key };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      invalidatesTags: (result, error, { link }) => [{ type: "ServiceAccount", id: link }],
    }),
    deleteKeys: builder.mutation<void, { link: string; keys: string[] }>({
      queryFn: async ({ link, keys }) => {
        try {
          const { request } = await import("../../services/cpln");
          // TODO add id and version here for not updating when there is another version already
          await request({
            method: "patch",
            url: link,
            body: { "$drop/keys": keys },
          });
          return { data: undefined };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      invalidatesTags: (result, error, { link }) => [{ type: "ServiceAccount", id: link }],
    }),
  }),
});

export const { useGetServiceAccountQuery, useAddKeyMutation, useDeleteKeysMutation } = serviceAccountApi;
